import { isObjectRecord } from "aic";
import { eHierarchyLevel } from "functions/api/enums";

export interface TlfLinkLocation {
  linkHierarchyName: string;
  linkLevel: eHierarchyLevel;
  linkHierarchyId: string;
}

/**
 * Type guard to verify an object is a `TlfLinkLocation`.
 *
 * @param obj - Value to inspect for `TlfLinkLocation` shape.
 * @returns True when the object matches the `TlfLinkLocation` interface.
 */
export const isTlfLinkLocation = (obj: unknown): obj is TlfLinkLocation => {
  if (!isObjectRecord(obj)) return false;

  return (
    // Check properties types
    typeof obj.linkHierarchyName === "string" &&
    Object.values(eHierarchyLevel).includes(obj.linkLevel as eHierarchyLevel) &&
    // Check enums
    typeof obj.linkHierarchyId === "string" &&
    typeof obj.linkLevel === "string" &&
    obj.linkLevel in eHierarchyLevel
  );
};
